import React from 'react';
//import {useSelector} from 'react-redux';
import styled from 'styled-components';
//import {selectFollowingComic} from '../../../reducers';
import ComicChapterCard from '../ComicChapterCard';
import ButtonShare from '../ButtonShare';
import GoChapterButton from '../GoChapterButton';
import LeftDecorator from '../../../assets/reface_left_side_decorator.png';
import RightDecorator from '../../../assets/reface_right_side_decorator.png';
import {mobileMediaQuery} from '../../../styles';

const ChapterFooter = props => {
    return (
        <Container>
            <ButtonShare comic={props.comic} chapter={props.chapter} />

            {props.chapter.number < props.comic.chapters.length && (
                <>
                    <StyledCard
                        chapter={props.comic.chapters[props.chapter.number]}
                        maskStart={true}
                        maskEnd={true}
                        width={230}
                        height={140}
                        horizontal={true}
                        hideData
                        hideSubtitle
                        replace
                    />
                    <GoChapterButton
                        chapter={props.comic.chapters[props.chapter.number]}
                        replace
                        trackNext
                    />
                </>
            )}
            <Decoration />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-top: 40px;
    padding: 40px 40px 100px 40px;
    background-color: #211921;
    flex-direction: column;
    position: relative;
`;

const StyledCard = styled(ComicChapterCard)`
  margin-top: 44px
  margin-bottom: 24px;
  z-index: 1;
`;

const Decoration = styled.div`
    position: absolute;
    top: 120px;
    background-image: url(${LeftDecorator}), url(${RightDecorator});
    background-size: contain, contain;
    background-position: left, right;
    background-repeat: no-repeat;
    height: 200px;
    width: 100%;
    pointer-events: none;

    ${mobileMediaQuery} {
        height: 123px;
    }
`;

export default ChapterFooter;
